var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"post-description"},[_c('div',{staticClass:"content"},[(_vm.enable_likes)?_c('Like',{attrs:{"liked":_vm.liked},on:{"toggleLike":_vm.toggleLike}}):_vm._e(),(_vm.showSocialShare)?_c('SocialShare',{attrs:{"sharing":{ url: _vm.shareUrl }}}):_vm._e(),_c('Options')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }